import { atom } from 'recoil';

export const triggerState = atom({
  key: 'reRenderTrigger',
  default: 0,
});
